import React from 'react';
import styled from 'styled-components';
import Checkbox from '../../../Checkbox';
import { MultiSelectValue } from '../../../MultiSelect/types';

import { RenderRadioContent } from '../../types';
import {
  StyledRadioMark,
  StyledRadioControlWrapper,
  StyledRadioWrapper,
  StyledRadioLabel,
  StyledRadioDecor,
  StyledRadioDecorWrapper,
  StyledRadioCheckboxesList,
  StyledRadioCheckboxesListItem,
} from './styles';
import { RadioItemWithCheckboxesProps } from './types';

const StyledEntitySectionLabel = styled.span`
  display: block;
  padding: 0 0.5rem 0.25rem;
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--muted-2);
`;

const renderRadioItemWithCheckboxes =
  (
    selectedValue: MultiSelectValue | undefined,
    withoutDisableFirstOption?: boolean,
    onChangeCheckedCheckboxes?: (value: string) => void,
    onSelectAll?: () => void
  ): RenderRadioContent<RadioItemWithCheckboxesProps> =>
  ({ value, label, decor, checked, disabled, checkboxes }) =>
    (
      <StyledRadioWrapper>
        <StyledRadioControlWrapper
          {...{ disabled }}
          onClick={onSelectAll ? (e) => { e.stopPropagation(); onSelectAll(); } : undefined}
          style={onSelectAll ? { cursor: 'pointer' } : undefined}
        >
          <StyledRadioMark {...{ checked }} />
          {decor && (
            <StyledRadioDecorWrapper>
              <StyledRadioDecor src={decor} alt={label} />
            </StyledRadioDecorWrapper>
          )}
          <StyledRadioLabel>{label || value}</StyledRadioLabel>
        </StyledRadioControlWrapper>
        <StyledRadioCheckboxesList>
          {checkboxes.length > 0 && !checkboxes[0]?.color && (
            <StyledEntitySectionLabel>Entities</StyledEntitySectionLabel>
          )}
          {checkboxes.map(({ value: checkBoxValue, color, ...props }, idx) => {
            const checkedSubItems = selectedValue?.checkedSubItems || [];
            const [firstCheckedSubItem] = checkedSubItems;
            const isCheckboxDisabled = withoutDisableFirstOption
              ? false
              : firstCheckedSubItem === checkBoxValue &&
                checkedSubItems.length === 1;

            return (
              <StyledRadioCheckboxesListItem key={idx}>
                <Checkbox
                  disabled={isCheckboxDisabled}
                  checked={checkedSubItems.includes(checkBoxValue)}
                  onChange={() =>
                    onChangeCheckedCheckboxes &&
                    onChangeCheckedCheckboxes(checkBoxValue)
                  }
                  tagColor={color}
                  {...props}
                />
              </StyledRadioCheckboxesListItem>
            );
          })}
        </StyledRadioCheckboxesList>
      </StyledRadioWrapper>
    );

export default renderRadioItemWithCheckboxes;
